<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <span class="cs-title">课件资料</span>
              <el-row class="grid-content">
                <el-row>
                  <el-col :span="16">
                    <breadcrumbNavigationBar :data="homeworkNavigationBarData"></breadcrumbNavigationBar>
                  </el-col>
                  <el-col :span="8" class="text-right">
                    <el-button
                       v-if="!USERMANAGER.isStudent"
                      type="danger"
                      size="medium"
                      :disabled="selectedRows.length==0"
                      @click="deleteSelectedCoursewareFiles"
                    >删除所选课件</el-button>
                    <el-button v-if="!USERMANAGER.isStudent" type="primary" size="medium" @click="onAdd">上传新文件</el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <pagination
                    v-loading="loading"
                    :data="coursewarekList"
                    :option="paginationOption"
                    @checkChange="onCheckChange"
                    @customEvent="customEventHandler"
                  ></pagination>
                </el-row>
              </el-row>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      width="600px"
      :visible.sync="dialogEditorVisible"
      top="8vh"
    >
      <coursewareFileEditor
        :data="editData"
        @closeDialog="onCloseEditor"
        @saveSuccess="onSaveSuccess"
      ></coursewareFileEditor>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      width="600px"
      :visible.sync="dialogMessageVisible"
      top="8vh"
      title="课件未解锁"
      :center="true"
    >
    <div class="backgroud-white">
      <div class="cs-coursewareFile-message-main">
        系统显示您的账号未在该（{{courseDate}}）课程中签到，目前无法查看或下载该课件。
        <br>
        解锁方式： <br>
        1. 按时参加线上课程 <br>
        2. 如果未能按时参加，补看相应视频也可解锁课件 <br>

      </div>
      <div class="cs-coursewareFile-message-footer">
        <el-button round type="primary" size="middle" @click="onClickMessageDlgBtn">确认</el-button>
      </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
/deep/ body .el-table .el-table-header th {
  height: 30px;
  padding: 5px 0px;
  color: #909399 !important;
  background-color: #fff !important;
}

.cs-contentContainer {
  .grid-content {
    margin-top: 15px;
    /deep/ .el-table .el-table-header th {
      height: 30px;
      padding: 5px 0px;
      color: #909399 !important;
      background-color: #fff !important;
    }
  }
}

.cs-coursewareFile-message-main{
  padding: 1rem 2rem 1rem 2rem;
}
.cs-coursewareFile-message-footer{
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
  button{
    width: 200px;
  }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import breadcrumbNavigationBar from "../../components/common/breadcrumbNavigationBar";
import coursewareFileEditor from "../../components/courseware/coursewareFileEditor";
import {
  getCoursewareFilesByWeek,
  getCourseware,
  removeCoursewareFiles,
  getCoursewareFileUrl
} from "../../service/courseware.service";
import { getStore, setStore } from "../../config/mUtils";
import global_ from "../../core/global";

export default {
  data() {
    return {
      loading: false,
      paginationOption: {},
      editData: {},
      dialogEditorVisible: false,
      dialogMessageVisible: false,
      courseType: 1,
      courseId: 0,
      campusId: 0,
      courseName: "",
      courseWeekName: "",
      week: 0,
      courseActivations: [],
      coursewarekList: [],
      selectedRows: [],
      homeworkNavigationBarData: {},
      courseDate:""
    };
  },
  components: {
    navigator,
    pagination,
    breadcrumbNavigationBar,
    coursewareFileEditor,
  },
  computed: {},
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      hasAddButton: false,
      addButtonText: "",
      hasSearch: false,
      hasChecked: !this.USERMANAGER.isStudent,
      allowMutipleCheck: true,
      checkedColumnTite: "",
      showAcitveColor: true,
      hideDisableRow: true,
      isStudent: this.USERMANAGER.isStudent,
      isNotStudent: !this.USERMANAGER.isStudent,
    };

    this.courseId = Number(this.$route.query.courseId);
    this.campusId = Number(this.$route.query.campusId);
    this.courseName = this.$route.query.courseName;
    this.courseType = Number(this.$route.query.courseType);
    this.week = Number(this.$route.query.week);
    this.courseWeekName = this.$route.query.courseWeekName;
    this.loadData();
    this.buildNavigations();
  },
  methods: {
    loadData() {
      this.loading = true;
      getCoursewareFilesByWeek(this.courseId, this.campusId, this.week)
        .then((result) => {
          if (!!result && result.success) {
            this.coursewarekList = result.data;
          } else if (result.message){
            this.$message.error(result.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    buildNavigations() {
      this.homeworkNavigationBarData = {
        name: "",
        navList: [],
        currentName: this.courseWeekName,
      };
      let link = "/coursewareManagement?courseType=" + this.courseType;
      if (this.courseType == 1) {
        this.homeworkNavigationBarData.navList.push({
          link: link,
          name: "大学补习",
        });
      } else if (this.courseType == 2) {
        this.homeworkNavigationBarData.navList.push({
          link: link,
          name: "应试英语",
        });
      } else {
        this.homeworkNavigationBarData.navList.push({
          link: link,
          name: "职业培训",
        });
      }

      this.homeworkNavigationBarData.navList.push({
        link: "/coursewareWeekly",
        name: this.courseName,
        data: {
          courseType: this.courseType,
          courseId: this.courseId,
          courseName: this.courseName,
          campusId: this.campusId,
        },
      });
    },

    onAdd() {
      this.showCoursewareEditor(0);
    },
    editCourseware(data) {
      this.showCoursewareEditor(data.CoursewareId);
    },
    showCoursewareEditor(id) {
      this.editData = {
        id: id,
        courseType: this.courseType,
        week: this.week,
        courseName: this.courseName,
        courseId: this.courseId,
        campusId: this.campusId,
      };
      this.dialogEditorVisible = true;
    },
    deleteCourseware(fileIdList) {
      this.$confirm("您确定要删除课件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeCoursewareFiles(fileIdList).then((result) => {
            if (!!result && result.success) {
              this.loadData();
            } else {
              this.$message.error(result.message);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onCloseEditor() {
      this.dialogEditorVisible = false;
    },
    onSaveSuccess(isAdd, row) {
      this.dialogEditorVisible = false;
      this.loadData();
    },
    onCheckChange(rows) {
      this.selectedRows = rows;
    },
    deleteSelectedCoursewareFiles() {
      let ids = [];
      _.each(this.selectedRows, (row) => {
        ids.push(row.FileStorageId);
      });
      this.deleteCourseware(ids);
    },
    customEventHandler(row) {
      if (row.action == "editCourseware") {
        this.editCourseware(row.data);
      } else if (row.action == "deleteCourseware") {
        let ids = [row.data.FileStorageId];
        this.deleteCourseware(ids);
      } else if (row.action == "downloadCoursewareDisallow"){
        this.courseDate = row.data.CourseDate;
        this.dialogMessageVisible = true;
      }
    },
    onClickMessageDlgBtn(){
      this.dialogMessageVisible = false;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/page/courseware/coursewareFiles.vue